import * as c from '@chakra-ui/react'
import { TranslateOptions, translateText } from 'src/utils/translateText'

import Carousel from '../carousel'
import { StarIcon } from '../icons/star.icon'

interface TestimonialsProps {
  testimonialsBanner: {
    title: TranslateOptions
    items: TestimonialsCardProps[]
    idSection?: string
  }
}

interface TestimonialsCardProps {
  name: TranslateOptions
  role: TranslateOptions
  text: TranslateOptions
  star: number
}

export default function Testimonials({
  testimonialsBanner,
}: TestimonialsProps) {
  const [isMobile] = c.useMediaQuery('(max-width: 720px)')

  return (
    <c.Container px={['s5', 0]} id={testimonialsBanner?.idSection}>
      <c.Heading size="md" textAlign="center" mb="l2">
        {translateText(testimonialsBanner?.title)}
      </c.Heading>

      <Carousel
        data={testimonialsBanner?.items}
        Content={Content}
        slidesPerView={isMobile ? 1 : 3}
      />
    </c.Container>
  )
}

function Content({ data }: { data: TestimonialsCardProps }) {
  return (
    <c.Flex
      p="s4"
      h={['full', '181px']}
      w={['full', '376px']}
      bg="primary.50"
      direction="column"
      borderRadius={['8px', '20px']}
      gap="s4"
      shadow="light"
    >
      <c.Flex justify="space-between">
        <c.Box>
          <c.Heading color="primary.500" fontSize="h-md.0">
            {translateText(data.name)}
          </c.Heading>

          <c.Text fontSize="t-sm.0">{translateText(data.role)}</c.Text>
        </c.Box>

        <c.Flex gap="s1">
          {Array.from({ length: 5 }).map((_, i) => (
            <c.Icon
              as={StarIcon}
              color={i < data.star ? 'primary.500' : 'black.400'}
              h="12px"
              w="12px"
              key={i}
            />
          ))}
        </c.Flex>
      </c.Flex>

      <c.Text color="black.400" fontSize="t-md.0" noOfLines={4}>
        {translateText(data.text)}
      </c.Text>
    </c.Flex>
  )
}
